var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"cwSliderWrapper"},[_c('cw-slider',_vm._b({on:{"valueChanged":_vm.valueChanged}},'cw-slider',_vm.sliderProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }